import React from "react";
import { Typography } from "antd";

const { Paragraph, Text } = Typography;

export const mcFAQ = [
  {
    question: "What is ECP & EFM?",
    answer: () => (
      <div>
        <Paragraph type="secondary">
          <Text>
            ECP (Excessive Chargeback Program) and EFM (Excessive Fraud
            Merchant) are Mastercard’s monthly monitoring programs for
            Mastercard transactions.
          </Text>{" "}
          ECP looks at all your chargebacks; EFM looks only at fraud
          chargebacks. If you exceed Mastercard’s thresholds, your acquirer
          may require risk controls and Mastercard may apply program
          actions/fees. Because they use Mastercard data only, they can look
          different from your overall chargeback rate.
        </Paragraph>
      </div>
    ),
  },
  {
    question: "What's the difference between ECM and HECM?",
    answer:
      "Both are tiers of ECP, based on all chargebacks. ECM applies at 100–299 chargebacks and a 1.50–2.99% rate in a month. HECM applies at 300+ chargebacks and a 3.00%+ rate. HECM carries stricter actions and higher fees than ECM.",
  },
  {
    question: "What is EFM and when does it apply?",
    answer:
      "EFM tracks only fraud chargebacks (reason codes 4837 and 4863). You enter EFM only when all four are true in the same month: 1,000+ Mastercard payments; Net Fraud Volume over $50,000 (over $15,000 in Australia); Fraud Rate over 0.50% (over 0.20% in Australia); and 3DS usage at or below 10% (at or below 50% for regulated merchants). EFM does not apply in Germany, India, or Switzerland.",
  },
  {
    question: "Why do ECP & EFM matter?",
    answer:
      "Staying over Mastercard’s thresholds for too long can lead to fines reaching tens of thousands of dollars, higher reserves, processing limits, or in severe cases losing your ability to process Mastercard. Tracking this data helps you catch issues early and fix them before penalties begin.",
  },
  {
    question: "What happens when I enter ECP or EFM?",
    answer:
      "Your processor/acquirer will notify you and may ask for a short remediation plan. Mastercard typically gives you time to bring numbers under the thresholds before fees apply; if you stay over, fees can start and your processor may add controls or limits. If you exceed both programs in the same month, only EFM is enforced. ECP keeps tracking in the background.",
  },
  {
    question: "How do I get out of ECP or EFM?",
    answer:
      "You must stay below the thresholds for 3 consecutive months. After 3 clean months, Mastercard removes you automatically. Going back over the limits resets the 3-month clock. If you exit EFM while ECP is still active, you move into ECP on the accumulated month.",
  },
  {
    question: "How is my status calculated?",
    answer:
      "Mastercard checks your Mastercard-only activity each month. Chargeback Rate = this month's chargebacks ÷ last month's successful payments. Fraud Rate = this month's fraud chargebacks ÷ last month's Mastercard payments. 3DS Usage = last month's Mastercard payments with 3DS ÷ all last month's Mastercard payments. Status is evaluated at the account level (not per billing descriptor) using your Stripe/Shopify data only.",
  },
  {
    question: "How is this different from my regular chargeback rate?",
    answer:
      "Your regular chargeback rate includes disputes from all card brands. ECP & EFM look only at Mastercard, and EFM counts only fraud chargebacks (4837/4863). So the Rate and Count shown here may be higher or lower than the numbers in your processor or CRM.",
  },
];
